export const enum ReviewableAction {
    Comment,
    Edit,
    Approve,
    RequestChanges,
    Reject
};
